import { Select } from "@p0security/ui";
import { useCallback } from "react";

import { FilterOption } from "../../types";

/**
 * A simple dropdown filter component used by the active requests and pre-approval pages.
 *
 * @param placeholder - The placeholder text for the dropdown
 * @param value - The current value of the dropdown
 * @param options - The options for the dropdown
 * @param onChange - The function to call when the value changes
 * @param width - The width of the dropdown (defaults to 200)
 */
export const DropdownFilter: React.FC<{
  placeholder: string;
  value: string | null;
  options: FilterOption[];
  onChange: (value: string | null) => void;
  width?: number;
}> = ({ placeholder, value, options, onChange, width = 200 }) => {
  const handleChange = useCallback(
    (val: string | null | undefined) => onChange(val ?? null),
    [onChange]
  );

  return (
    <Select
      allowClear
      placeholder={placeholder}
      /* eslint-disable-line react/forbid-component-props */ style={{ width }}
      options={options}
      value={value}
      onChange={handleChange}
    />
  );
};
